import { ReactTFC } from "../../../../../../utils/fp/missing-ts-parts";
import { PDPAvailabilityNotificationsTranslationsProps } from "../types";
import { ReactComponent as MailSvg } from "../../../../../../assets/icons/mail.svg";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../../../../../styles/breakpoints";
import { fontColor, FONTS, fontSize } from "../../../../../../styles/fonts";
import React from "react";
import { T } from "../../../../../../components/T";

export const PDPAvailabilityNotificationHeadlineElements: ReactTFC<{
  translations: PDPAvailabilityNotificationsTranslationsProps;
}> = props => {
  return (
    <>
      <MailSvg
        css={css`
          height: 24px;
          margin-bottom: 16px;

          flex-shrink: 0;
          ${CSS_MQ.atLeastMd} {
            height: 35px;
            margin-bottom: 25px;
          }

          ${CSS_MQ.lowResNotebook} {
            height: 24px;
            margin-bottom: 16px;
          }
        `}
      />

      <span
        css={[
          FONTS.SwarovskiFutura500,
          fontColor.black,
          fontSize.x2,
          css`
            margin-bottom: 30px;
            ${CSS_MQ.lowResNotebook} {
              margin-bottom: 20px;
            }

            text-align: center;
            text-transform: uppercase;
          `,
        ]}
      >
        {<T>{props.translations.emailNotificationLabel}</T>}
      </span>
    </>
  );
};
